import { Link } from 'react-router-dom';
import PageWrapper from 'components/layout/PageWrapper';
import SubGallery from 'components/SubGallery';

const images = [
    { src: '/images/viewPhotos/isoView.png',   alt: 'Subby isometric view' },
    { src: '/images/viewPhotos/sideView.png',  alt: 'Subby side view' },
    { src: '/images/viewPhotos/topView.png',   alt: 'Subby top view' },
    { src: '/images/viewPhotos/frontView.png', alt: 'Subby front view' },
];

const PastYear1819 = () => (
    <div style={{ backgroundColor: 'var(--color-bg-dark)', color: 'var(--color-text)' }}>
        <PageWrapper>
            <Link to="/fleet" className="fleet-back-link">← Back to The Fleet</Link>
            <h1 style={{ color: 'var(--color-accent)', fontSize: '60px', textAlign: 'center', fontFamily: "'NCAA Missouri Tigers', Arial" }}>Subby</h1>
            <p style={{ fontSize: '32px', margin: '0', fontWeight: 'normal', textAlign: 'center' }}>2018-2019</p>
            <br />
            <SubGallery images={images} bgColor="#DDD" />
        </PageWrapper>
    </div>
);

export default PastYear1819;
